





















































import Vue, { PropType } from 'vue';
import SnakeShortCombo from '@/assets/figma/GRAFISK ELEMENT/SNAKE STANDARD.svg';
import SnakeShortGreen from '@/assets/figma/GRAFISK ELEMENT/SNAKE TEKNOLOGI.svg';
import SnakeShortPurple from '@/assets/figma/GRAFISK ELEMENT/SNAKE MEDIA.svg';
import SnakeLongV1Green from '@/assets/images/snake1_long_tech.svg';
import SnakeLongV1Purple from '@/assets/images/snake1_long_media.svg';
import SnakeLongV1Combo from '@/assets/images/snake1_long_combo.svg';
import SnakeLongV2Green from '@/assets/images/snake2_long_tech.svg';
import SnakeLongV2Purple from '@/assets/images/snake2_long_media.svg';
import SnakeLongV2Combo from '@/assets/images/snake2_long_combo.svg';
import SnakeLongV3Green from '@/assets/images/snake3_long_tech.svg';
import SnakeLongV3Purple from '@/assets/images/snake3_long_media.svg';
import SnakeLongV3Combo from '@/assets/images/snake3_long_combo.svg';

export enum ColorScheme {
  Combo = 'combo',
  Purple = 'purple',
  Green = 'green'
}

export enum Variant {
  Short = 'short',
  Long = 'long'
}

export default Vue.extend({
  name: 'Snake',
  components: {
    SnakeShortCombo,
    SnakeShortGreen,
    SnakeShortPurple,
    SnakeLongV1Green,
    SnakeLongV1Combo,
    SnakeLongV1Purple,
    SnakeLongV2Green,
    SnakeLongV2Combo,
    SnakeLongV2Purple,
    SnakeLongV3Green,
    SnakeLongV3Combo,
    SnakeLongV3Purple,
  },
  props: {
    colorScheme: {
      type: String as PropType<ColorScheme>,
      default: () => ColorScheme.Combo.toString(),
      validator: (value: string): boolean => [
        ColorScheme.Combo.toString(),
        ColorScheme.Green.toString(),
        ColorScheme.Purple.toString(),
      ].indexOf(value) !== -1,
    },
    variant: {
      type: String as PropType<Variant>,
      default: () => Variant.Short.toString(),
      validator: (value: string): boolean => [
        Variant.Short.toString(),
        Variant.Long.toString(),
      ].indexOf(value) !== -1,
    },
    version: {
      type: Number,
      default: () => -1,
    },
  },
  computed: {
    classes() {
      return {
        'variant-short': this.variant === 'short',
        'variant-long': this.variant === 'long',
      };
    },
    finalVersion() {
      if (this.version >= 0) {
        return this.version;
      }
      return Math.floor(Math.random() * Math.floor(3));
    },
  },
});
